export enum SubscriptionUpgradeReason {
  MissingFeature,
}
